"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a request returns Forbidden
 * on operation for accessing child enrollments
 * @param {string} childUserId the child id
 */
class ForbiddenAccessToChildEnrollments extends client_library_1.ExtendableError {
    constructor(childUserId) {
        super(`Forbidden operation for accessing child enrollments: ${childUserId}`);
        this.childUserId = childUserId;
    }
}
exports.default = ForbiddenAccessToChildEnrollments;
//# sourceMappingURL=ForbiddenAccessToChildEnrollments.js.map